"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyTrainerList = void 0;
exports.trainerListSetMock = trainerListSetMock;
exports.trainerList = trainerList;
exports.useQueryTrainerList = useQueryTrainerList;
exports.useInfiniteQueryTrainerList = useInfiniteQueryTrainerList;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function trainerListSetMock(mock) {
    setMock = mock;
}
async function trainerList(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/v1/trainer`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params, 'trainer-store')
        : client.getRequestConfig(params, 'trainer-store');
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.perPage = params.perPage;
    queryParams.page = params.page;
    queryParams.ids = params.ids;
    queryParams.firstName = params.firstName;
    queryParams.lastName = params.lastName;
    queryParams.sortAsc = params.sortAsc;
    queryParams.sortDesc = params.sortDesc;
    queryParams.getAll = params.getAll;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.trainerStoreIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyTrainerList = 'trainer-store:trainerList:get';
function useQueryTrainerList(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyTrainerList, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryTrainerList(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyTrainerList, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = trainerList(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=trainer-list.js.map